<template>
  <!-- 이미지 형 -->
  <div>
    <v-card class="line-template-edit-area">
      <template-image :imageUrl="content.imageUrl"></template-image>
      <div class="my-3"></div>
      <template-button :buttons="content.button"></template-button>
    </v-card>
  </div>
</template>

<script>
import templateImage from '../item/templateImage'
import templateButton from '../item/templateButton'
export default {
  props: {
    content: {
      type: Object
    }
  },
  components: {
    templateImage,
    templateButton
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.line-template-edit-area{
  width: 302px;
  border-radius:15px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/line/templates/lineTemplateImage.vue